import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const mtsInvestList = {
    colorNumber: '#e51908',
    list: [
        'Увеличить количество страниц сайта в&nbsp;индексе поисковой системы посредством технической оптимизации',
        'Увеличить посещаемость на&nbsp;новые тематические посадочные страницы',
        'Обеспечить рост трафика в&nbsp;блоге',
    ],
};

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="mts-invest-task" bigPaddings={true}>
                <CommonTitle>Задачи</CommonTitle>
                <div className="mts-invest-task__wrapper">
                    <CommonUsualText className="mts-invest-task__info">
                        С&nbsp;помощью технической оптимизации проекта и&nbsp;поисковой оптимизации
                        страниц нам нужно было:
                    </CommonUsualText>
                    <CommonOlList className="mts-invest-task__list" CommonOlList={mtsInvestList} />
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
